import styled from 'styled-components';

export default styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 1rem;
  width: 1rem;
  background-color: ${({ theme }) => theme.grayLightColor};
  &:after {
    content: "";
    position: absolute;
    display: none;
    left: .25rem;
    top: .05rem;
    width: .25rem;
    height: .5rem;
    border: solid white;
    border-width: 0 3px 3px 0;

    transform: rotate(45deg);
  }
`;
